module.exports = __webpack_public_path__ + "static/media/logout.1baf5193.svg";